import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/index'
// import user from '@/view/system/menu'
// import userCenter from '@/view/userCenter'
import map from '@/view/dataStatistics/map'
import home from "@/view/home"
// import CD from '@/components/CD'
Vue.use(Router)
export const constantRouterMap = [{
  path: '/login',
  component: (resolve) => require(["@/view/login"], resolve),
  hidden: true
},

{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: home,
  }]
},
{
  path: "/",
  redirect: "/home",
  // meta: { title: '用户登陆', icon: '' },
},

  // {
  //   path: '/userCenter',
  //   component: Layout,
  //   hidden: true,
  //   redirect: 'noredirect',
  //   children: [{
  //     path: 'center',
  //     component: userCenter,
  //     name: 'routers.personCenter',
  //     title: 'routers.personCenter',
  //     meta: {
  //       title: 'routers.personCenter',
  //       icon: 'jiaoseguanli',
  //       label: '个人中心'
  //     }
  //   }]
  // },
  // {
  //   path: '/datastatistics',
  //   component: Layout,
  //   type:0,
  //   icon: 'servicer1',
  //   meta: { 
  //     title: '数据统计',
  //     icon: 'servicer1',
  //    },
  //   children: [{
  //     path: '/map',
  //     component:map,
  //     name:'地图',
  //     meta: {
  //       title: '地图',
  //       icon: 'bushutu1',
  //     }
  //   },
  //   {
  //     path: '/CD',
  //     component:CD,
  //     name:'数据中心',
  //     meta: {
  //       title: '数据中心',
  //       icon: 'database-full',
  //     }
  //   }
  // ],

  // }

]
const createRouter = () => new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes: constantRouterMap
})
const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}
export default router